module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/what_is_bitcoinsv-ae843199998a5e56.png"+" 1643w",
        images: [{path: __webpack_public_path__ + "assets/images/what_is_bitcoinsv-ae843199998a5e56.png",width: 1643,height: 861}],
        src: __webpack_public_path__ + "assets/images/what_is_bitcoinsv-ae843199998a5e56.png",
        toString: function(){return __webpack_public_path__ + "assets/images/what_is_bitcoinsv-ae843199998a5e56.png"},
        
        width: 1643,
        height: 861
      }